import config from "PFConfig";

window.PF = {
  Initializers: {},
  config
};
